import { gql } from '@apollo/client';

export const GET_AS_OF_DATES = gql`
  query GetAsOfDates($portfolioId: String!, $institutionId: String) {
    asOfDates(portfolioId: $portfolioId, institutionId: $institutionId) {
      asOfDate
      taxesFedRate
      taxesStateRate
      taxesCostOfFunds
      totalAssets
      totalRiskBasedAssets
      totalCapital
      totalTier1Capital
      modifiedDt
    }
  }
`;
